<div *ngIf="!showSucursalInfo">
  <div class="sucursal-container">
    <div class="title-and-button">
      <button
        *ngIf="!loggedUser?.isResponsible"
        (click)="goToAgregarSucursal()"
        mat-raised-button
        [disabled]="loading"
        class="button-add"
      >
        + Agregar sucursal
      </button>
    </div>
  </div>

  <div class="search-branch">
    <mat-form-field class="input-yaca" style="width: 100%">
      <input matInput [formControl]="search" autocomplete="off" type="text" placeholder="Buscar sucursal" />
    </mat-form-field>
  </div>

  <div *ngIf="loading" style="display: flex; justify-content: center">
    <mat-spinner [diameter]="70"></mat-spinner>
  </div>

  <div *ngIf="!loading">
    <div class="cont-padre-sucursales">
      <div
        class="contenedor-de-sucursales"
        *ngFor="let branch of filterBranches | paginate : { itemsPerPage: 4, currentPage: pageActual }"
      >
        <div class="sucursales">
          <div class="sucursal-nombre" (click)="selectedBranch = branch; showSucursalInfo = true">
            <span>{{ branch.name }}</span
            ><br />
            <div class="sucursal-direccion">
              Código: {{ branch.id }} - {{ branch.address ? branch.address : 'Sin dirección' }}
            </div>
          </div>
          <div style="display: flex; align-items: center" *ngIf="!loggedUser?.isResponsible">
            <button mat-icon-button class="button-edit" (click)="goToEditSucursal(branch)">
              <mat-icon style="color: #ff6600">edit</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <pagination-controls
        class="my-pagination"
        maxSize="7"
        previousLabel=""
        nextLabel=""
        (pageChange)="pageActual = $event"
      ></pagination-controls>
    </div>
  </div>
</div>

<div *ngIf="showSucursalInfo">
  <app-branch-info
    [branch]="selectedBranch"
    [loggedUser]="loggedUser"
    [userModel]="userModel"
    (resetShowInfo)="showSucursalInfo = false"
  ></app-branch-info>
</div>
